import { dispatchSetConnectionStatus } from '$comp/main/root.action'
import {
  createUserWaitReporter,
  UserWaitPendingAction,
} from '$logic/analytics/reporters/user-wait'

export const webSocketConnectionEstablishmentReporter = createUserWaitReporter(
  UserWaitPendingAction.WEB_SOCKET_CONNECTION,
)

export default () => {
  webSocketConnectionEstablishmentReporter.start()
  analite('TRY_TO_CONNECT_WEB_SOCKET')
  dispatchSetConnectionStatus('authenticating')
}
